@switch (columnName) {
  @case ('status') {
    <div class="task-status-cell">
      <app-ui-pill
        [name]="element.isPaused ? element.pauseStatusSnapshot : element[columnName]"
      ></app-ui-pill>
      @if (element.isPaused) {
        <app-department-paused-badge></app-department-paused-badge>
      }
    </div>
  }
  @case ('pausable') {
    <div class="pausable-cell">
      {{ (element.pausable ? 'yes' : 'no') | translate }}
    </div>
  }
  @case ('hasAttachments') {
    @if (element.hasAttachments) {
      <mat-icon [attr.aria-label]="'hasAttachments' | translate">attach_file</mat-icon>
    }
  }
  @case ('lastPerformed') {
    <div>
      {{ !element['lastWorkDate'] ? '-' : (element['lastWorkDate'] | date) }}
    </div>
  }
  @case ('expiry') {
    {{ element['expiryDate'] | date }}
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions; track position?.id ?? position) {
      <div>
        {{ position?.name }}
      </div>
    }
    @for (user of element.responsibleForUsers; track user?.id ?? user) {
      <div>
        {{ user?.name }}
      </div>
    }
    @for (
      positionGroup of element.responsibleForPositionGroups;
      track positionGroup?.id ?? positionGroup
    ) {
      <div>
        {{ positionGroup?.name }}
      </div>
    }
    @for (role of element.responsibleForRoles; track role?.id ?? role) {
      <div>
        {{ role?.name }}
      </div>
    }
  }
  @case ('actions') {
    <app-ui-button
      color="primary"
      [buttonType]="isHACCP ? 'stroked' : 'secondary'"
      [icon]="element.isDraft ? '' : isHACCP ? 'checklist' : 'add'"
      text="{{ (element.isDraft ? 'openDraft' : 'perform') | translate }}"
      [routerLink]="performRoute + '/' + element['id']"
      [disabled]="element.isDisabled || !element.canPerform || !hasPermissionToPerform"
      [tooltip]="
        (!hasPermissionToPerform ? 'noAccess' : '') ||
          (element.isDisabled || !element.canPerform ? 'notResponsibleForPerformingTask' : '')
          | translate
      "
    ></app-ui-button>
  }
  @case ('restore') {
    <app-ui-button
      appConfirmDialog
      appStopClickPropagation
      confirmTitle="restore"
      confirmMessage="youAreRestoring"
      confirmButton="primary"
      [confirmEntityName]="element['name']"
      (confirmed)="restore()"
      buttonType="secondary"
      text="{{ 'restore' | translate }}"
      [privilege]="Privileges.TaskRestore"
    ></app-ui-button>
  }
  @case ('reactivate') {
    <app-ui-button
      appConfirmDialog
      appStopClickPropagation
      confirmTitle="reactivate"
      confirmButtonText="reactivate"
      [confirmEntityName]="element['name']"
      confirmMessage="youAreReactivating"
      [showAreYouSure]="true"
      (confirmed)="reactivate()"
      text="{{ 'reactivate' | translate }}"
      buttonType="secondary"
      [privilege]="Privileges.TaskEnable"
    ></app-ui-button>
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
